import { shopperDetails as TEXT } from 'locales/en/cart';
import { DEFAULT_COUNTRY } from 'utils/constants';
import yup, { fullNameRegex } from 'utils/yupHelpers';

export const FIELD_NAMES = {
  name: 'name',
  phone_country: 'phone_country',
  phone: 'phone',
  email: 'email',
};

export const defaultValues = {
  [FIELD_NAMES.name]: '',
  [FIELD_NAMES.phone_country]: DEFAULT_COUNTRY,
  [FIELD_NAMES.phone]: '',
  [FIELD_NAMES.email]: '',
};

const schema = yup.object().shape({
  [FIELD_NAMES.name]: yup
    .string()
    .test('name_length', 'Name and surname must be each at least 3 letters long.', (name) => {
      if (!name) {
        return;
      }

      const fullName = name.split(' ');

      if (fullName.length < 2) {
        return false;
      }

      const [firstName, lastName] = fullName;

      return Boolean(firstName.length >= 3 && lastName?.length >= 3);
    })
    .matches(fullNameRegex, TEXT.errors.name.fullName)
    .required(TEXT.errors.name.required),
  [FIELD_NAMES.phone_country]: yup.object().shape({
    name: yup.string().required(TEXT.errors.phone.required),
    dial_code: yup.string(),
    code: yup.string(),
  }),
  [FIELD_NAMES.phone]: yup
    .string()
    .phoneNumber(TEXT.errors.phone.invalid)
    .required(TEXT.errors.phone.required),
  [FIELD_NAMES.email]: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
});

export default schema;
